import { render } from "./HeaderUzgent.vue?vue&type=template&id=1cb191e6&scoped=true"
import script from "./HeaderUzgent.vue?vue&type=script&lang=js"
export * from "./HeaderUzgent.vue?vue&type=script&lang=js"

import "./HeaderUzgent.vue?vue&type=style&index=0&id=1cb191e6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb191e6"]])

export default __exports__